<!-- prettier-ignore -->

<div class="event-qr-container">
    <div class="event-qr-container__header">
        <img draggable="false" [src]="rest?.apiUrlBase + '/storage/' + qrCode">
    </div>
    <hr class="event-qr-hr">
    <div class="event-qr-container__body">
        <!-- <span>{{item?.name?.[translate.currentLang]}}</span> -->
        <span>{{user}}</span>
        <!-- <span>ID: {{item?.id}}</span> -->
    </div>
</div>